import React from "react";

import styles from "./paymentMethods.module.scss";

type CreditCardIconProps = {
	name?: string;
};

const CreditCardIcon = ({ name = "unknown" }: CreditCardIconProps) => {
	return (
		<>
			{name !== "unknown" && (
				<div className={styles.iconHolder}>
					<svg>
						<use href={`#${name}_sprite_icon`}></use>
					</svg>
				</div>
			)}
		</>
	);
};

export default CreditCardIcon;
